var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-bg {\n  background-image: url(" + escape(require("../../assets/images/Rectangle 7.svg")) + ");\n  background-repeat: no-repeat;\n  background-position: top;\n  background-size: cover;\n  padding: 40px 0px 50px 0px;\n  width: 100%; }\n\n.example-full-width {\n  width: 100%; }\n\n.refer-btn {\n  background-color: #ccc;\n  border-radius: 25px;\n  padding: 10px 25px;\n  border: 0;\n  color: #3023AE; }\n\n.btn-color {\n  background-color: #4E44D8; }\n\n.br-25 {\n  border-radius: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/app/reset-password/reset-password.component.scss
// module id = ../../../../../src/app/reset-password/reset-password.component.scss
// module chunks = main